import CookieService from '../services/cookie';
import { initScrollTop } from './use-scroll-top';

document.addEventListener('DOMContentLoaded', () => {
  initiateCloseCookiePopupHandler();
  initScrollTop({
    scrollUpButton: document.getElementById('back-to-top'),
    visibilityReason: { percentage: 10 },
    paddingBottom: 100,
  });
});

function initiateCloseCookiePopupHandler() {
  const cookiePopup = document.getElementById('cookie-popup-block');

  if (cookiePopup === null) {
    return;
  }

  cookiePopup
    .querySelector('.button--primary')
    .addEventListener('click', (event) => {
      event.preventDefault();
      CookieService.acceptCookie();
      cookiePopup.style.display = 'none';
      if (typeof LiveAgent === 'undefined') {
        return;
      }
  
      const containerElement = document.getElementById('chatButton');
      const currentTestId = containerElement.getAttribute('data-testid');
  
      const LiveAgentButton = LiveAgent.createButton(
        LiveAgentButtonCode,
        containerElement,
      );
  
      if (currentTestId) {
        const buttonElement = document.getElementById(LiveAgentButton.elementId);
        buttonElement.setAttribute('data-testid', currentTestId);
      }
    });
}